<script lang="ts">
	import __ from '$lib/stores/TranslationStore';
	import Simulations from '$lib/components/Simulations/Landing/Simulations.svelte';
	import Help from '$lib/components/Simulations/Landing/Help.svelte';
	import Title from '$lib/components/SEO/Title.svelte';
	import Description from '$lib/components/SEO/Description.svelte';
</script>

<svelte:head>
	<Title content={`${$__('Simuladores: Solução Ideal')} - Poupança no Minuto`} />
	<Description
		content={$__(
			'Explore as melhores opções para o seu novo crédito habitação com os nossos simuladores especializados. A Poupança no Minuto oferece ferramentas completas para ajudá-lo a comparar taxas, condições e encontrar a solução perfeita para a compra da sua casa. Inicie a sua jornada rumo à casa dos seus sonhos com confiança.'
		)}
	/>
	<meta property="og:image" content="/og/open-graph-home.png" />
</svelte:head>

<Simulations />
<Help />
